import { Box, Heading } from 'grommet'
import Image from 'next/image'
import styled from 'styled-components'

import SoftStar from '@public/images/cases/big-data-solution-for-online-bank/soft-star.svg'
import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(Box)`
  background: ${({ theme }) => theme.newColors.gradientGray};
  height: 710px;
  overflow: hidden;
  position: relative;

  ${({ theme }) => theme.below.laptopL`
    height: 920px;
  `}

  ${({ theme }) => theme.below.laptopM`
    height: 1050px;
  `}

  ${({ theme }) => theme.below.laptop`
    height: 1190px;
  `}

  ${({ theme }) => theme.below.tablet`
    height: 900px;
  `}

  ${({ theme }) => theme.below.tabletS`
    height: 800px;
  `}

  ${({ theme }) => theme.below.mobileL`
    height: 680px;
  `}

  ${({ theme }) => theme.below.mobileM`
    height: 580px;
  `}
`

export const SoftStarRight = styled(SoftStar)`
  height: auto;
  left: 39%;
  margin: 0 auto;
  position: absolute;
  top: 73%;
  width: 30px;

  ${({ theme }) => theme.below.laptopL`
    left: 30%;
    top: 75%;
  `}

  ${({ theme }) => theme.below.laptopM`
    display: none;
  `}
`

export const SoftStarLeft = styled(SoftStar)`
  height: auto;
  left: 15%;
  margin: 0 auto;
  position: absolute;
  top: 16%;
  width: 20px;

  ${({ theme }) => theme.below.laptopL`
    left: 6%;
    top: 10%;
  `}

  ${({ theme }) => theme.below.laptopM`
    left: 4%;
    top: 8%;
  `}

  ${({ theme }) => theme.below.tablet`
    left: 4%;
    top: 8%;
  `}

  ${({ theme }) => theme.below.tabletS`
    left: 5%;
    top: 9%;
  `}

  ${({ theme }) => theme.below.mobileL`
    display: none;
  `}
`

export const SideImage = styled(Image)`
  bottom: ${({ theme }) => theme.spaces[5]}px;
  height: 645px;
  position: absolute;
  right: 50px;
  width: auto;
  z-index: 1;

  ${({ theme }) => theme.below.laptopL`
    top: unset;
    bottom: ${theme.spaces[3]}px;
  `}

  ${({ theme }) => theme.below.laptop`
    bottom: ${theme.spaces[5]}px;
    height: 600px;
  `}

  ${({ theme }) => theme.below.tablet`
    height: 500px;
    right: 20px;
  `}

  ${({ theme }) => theme.below.tabletS`
    height: 360px;
  `}

  ${({ theme }) => theme.below.mobileL`
    height: 300px;
  `}

  ${({ theme }) => theme.below.mobileM`
    height: 250px;
  `}

  ${({ theme }) => theme.below.mobileS`
    height: 200px;
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'blog')}

  color: ${({ theme }) => theme.newColors.lightOrange};
  max-width: 500px;
  position: relative;
  text-transform: uppercase;
  z-index: 2;

  ${({ theme }) => theme.below.tablet`
    max-width: 570px;
    font-size: 50px;
    line-height: 70px;
    margin-bottom: ${theme.spaces[3]}px;
  `}

  ${({ theme }) => theme.below.tabletS`
    ${({ theme }) => theme.getTypography('desktop', 'title', 'title1')}

    max-width: 350px;
  `}

  ${({ theme }) => theme.below.mobileL`
    ${({ theme }) => theme.getTypography('mobile', 'title', 'large')}

    margin-bottom: ${theme.spaces[2]}px;
  `}

  ${({ theme }) => theme.below.mobileM`
    font-size: 24px;
    line-height: 32px;
  `}
`

export const TextWrapper = styled(NormalizedWrapper)`
  margin-top: 80px;

  ${({ theme }) => theme.below.laptopL`
    margin-bottom: ${theme.spaces[4] + theme.spaces[3]}px;
    margin-top: ${theme.spaces[5]}px;
  `}

  ${({ theme }) => theme.below.laptopM`
    margin-left: ${theme.spaces[4]}px;
  `}

  ${({ theme }) => theme.below.laptop`
    margin-left: ${theme.spaces[2]}px;
    margin-top: ${theme.spaces[5]}px;
  `}

  ${({ theme }) => theme.below.tablet`
    margin-top: ${theme.spaces[5]}px;
    margin-bottom: ${theme.spaces[5]}px;
    align-items: flex-start;
  `}

  ${({ theme }) => theme.below.mobileL`
    margin-top: ${theme.spaces[3]}px;
  `}
`
